import { AppState } from '../index';
import { loaderFeatureKey, LoaderState } from './loader.reducer';
import { createSelector } from '@ngrx/store';

export const loaderFeature = (state: AppState) => state[loaderFeatureKey];
export const selectIsLoading = createSelector(loaderFeature, (state: LoaderState) => state.counter > 0);
